import { getRouteApi } from "@tanstack/react-router";
import type { SitePublicData } from "./site-config.functions";

const rootApi = getRouteApi("__root__");

export function useSiteData(): SitePublicData {
  return rootApi.useLoaderData();
}